/**
 * Collection Vue Component
 * ------------------------------------------------------------------------------
 * Template in sections/collection.liquid
 * 
 */

import Vue from 'vue';

import Ajaxinate from '../vendor/ajaxinate';

function getParameterByName(name, url) { // TODO: Move util function to a mixin
    if (!url) url = window.location.href;
    name = name.replace(/[[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

Vue.component('collection-page', {
    data() {
        return {
          isFiltersOpen: false
        }
    },

    mounted() {
        new Ajaxinate({
            container: '.collection__products',
            pagination: '.collection__pagination',
            method: 'click'
        });
    },

    methods: {
        toggleFilters() {
            this.isFiltersOpen = !this.isFiltersOpen;
        },

        sort(e) {
            var sortValue = e.target.value;
            var sortQuery = '';
      
            if (sortValue !== e.target.dataset.defaultSortby) {
                sortQuery = 'sort_by=' + sortValue;
            }

            var url = window.location.href.replace(window.location.search, '');
            var queryStringValue = getParameterByName('q');
            var query = queryStringValue !== null ? queryStringValue : '';

            if (sortQuery.length) {
                var urlStripped = url.replace(window.location.hash, '');
                query = query !== '' ? '?q=' + query + '&' : '?';

                window.location.href = urlStripped + query + sortQuery;
            } else {
                // clean up our url if the sort value is blank for default
                window.location.href = url;
            }
        }
    }
});